import styled from "styled-components";
import { Button } from "@vitalsource/vstui";
import { List } from "@vitalsource/vstui/labs";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import { cloud, ninja } from "@vitalsource/vstui/colors";

export const ThemedButton = createThemedComponent(Button, props => ({
  Button_paddingHorizontal_withIconMedium: "16px",
  Button_borderRadius: 0,
  Button_minHeight_medium: 44,
  Button_boxShadow_whiteNaked_focus: `0 0 0 2px ${props.theme.vstui.color.white}`,
  Button_color_whiteNaked_focus: props.theme.vstui.color.white
}));

export const IconTitle = styled.span`
  text-align: center;
`;

export const IconList = styled.ul`
  box-sizing: content-box;
  display: flex;
  flex-wrap: wrap;
  padding: 13px 10px 16px 10px;
  width: 250px;
`;

export const IconListItem = styled.li`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-basis: 33%;

  &:nth-child(n + 4) {
    padding-top: 15px;
  }

  a {
    align-items: center;
    color: inherit;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    width: 100%;

    span {
      margin-top: 4px;
    }
  }
`;

export const ThemedList = createThemedComponent(List, props => ({
  List_backgroundColor: props.theme.vstui.color.white,
  // Color from design, but don't see in vstui
  ListItem_color: "#1C1C1C",
  ListItem_fontSize: "15px",
  ListHeader_fontSize: "14px",
  ListHeader_fontWeight: "500",
  ListHeader_textTransform: "capitalize"
}));

export const ReadOffline = styled.div`
  background: ${cloud.getShade(1)};
  min-height: 75px;
  padding: 15px 40px;
  text-align: center;
  width: 100%;

  p {
    color: ${ninja.getShade(10)};
    font-size: 1.3rem;
    line-height: 1.5;
    margin: 5px 0 8px;
    padding: 0;
  }
`;

export const PromoteMobile = styled.button`
  background: ${cloud.getShade(1)};
  border: 0;
  display: flex;
  flex-direction: row;
  padding: 17px 25px;
  width: 270px;
`;

export const Watkins = styled.img`
  height: 46px;
  width: auto;
`;

export const PromoteMobileDetails = styled.div`
  color: ${cloud.getShade(10)};
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  margin-left: -5px;
`;

export const CurrentUser = styled.div`
  color: ${cloud.getShade(10)};
  display: flex;
  flex-direction: column;
  padding: 24px 20px 22px;
  width: 280px;
`;

export const FullName = styled.span`
  font-size: 1.7rem;
  margin-bottom: 6px;
`;

export const Email = styled.span`
  font-size: 1.2rem;
`;
